import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { hasLocationPermission } from './location-permission-helpers';

export function RequireLocationPermission({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const granted = await hasLocationPermission();
      if (!granted) {
        navigate('../location_info', { replace: true });
      }
    })();
  }, [navigate]);

  return <>{children}</>;
}
